module.exports = __webpack_public_path__ + "img/plb8.52e82186.png";